import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  legend: {
    maxWidth: 600
  },
  legendWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  legendPanel: {
    fontSize: 14,
    color: colour.grey[200],
    padding: "10px 0",
    textAlign: "center",
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  legendLabel: {
    fontWeight: 600
  },
  svg: {
    width: 34,
    height: 34,
    marginRight: 10
  },
  offWrapper: {
    background: colour.grey[500],
    padding: "0 10px",
    borderRadius: 5
  },
  offWrapperPanel: {
    justifyContent: "space-between"
  },
  offWrapperIcon: { display: "flex", alignItems: "center" },
  breakdownTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200],
    margin: 0,
    display: "flex",
    justifyContent: "space-between"
  },
  breakdownToggle: {
    display: "flex"
  },
  breakdownTitleText: {
    alignSelf: "center",
    marginRight: 10
  },
  breakdownToggleTitle: {
    marginRight: 5,
    alignSelf: "center"
  },
  breakdownToggleLabel: {
    display: "flex",
    margin: "0 10px",
    alignSelf: "center"
  },
  breakdownToggleUnit: {
    alignSelf: "center"
  },
  legendWrapperGreyscale: {
    filter: "grayscale(100%)"
  }
});
